<div class="template-container">
  <cam-input-radio [input]="this.reachInput"></cam-input-radio>
  <cam-loader [isLoading]="this.requestState.isLoading()">
    @if (this.reachInput.changeValue$ | async) {
      <div class="reachClientBox">
        @if (this.currentItem.department && this.currentItem.professions) {
          <div class="my-space-2">
            <cam-department-professions
              class="ta-c"
              [professions]="this.currentItem.professions"
            ></cam-department-professions>
          </div>
        }
        @if (this.form(); as form) {
          @if (!this.requestState.isLoading()) {
            <div class="form">
              <cam-form
                [inputs]="form"
                [canDisplayButton]="false"
                [askValidation$]="this.askValidation$"
                (valid)="this.send($event)"
                (isFormValid)="this.formValid($event)"
              >
              </cam-form>
            </div>
          }
        }
      </div>
    }

    <div class="cta justify-content-end">
      <cam-button
        (action)="this.askValidation()"
        [state]="!this.isValidForm && ((this.reachInput.changeValue$ | async) || false) ? 'disabled' : 'classic'"
      >
        {{ 'core.communicationhandler.template.send' | translate }}
      </cam-button>
    </div>
  </cam-loader>
</div>
